<template>
    <div class="content-wrapper">
        <PageHeader screenName="Auditoria" :linkItems="linkItems" />

        <main class="card hidden_overflow_tabela">

            <validation-observer ref="itemRules">

                <b-row class="pt-1 px-2 mb-1 mt-1">

                    <!-- Departamento Regional -->
                    <b-col lg="3" md="6" sm="12">
                        <b-form-group label="Departamento Regional*" label-for="departamento-input"
                            label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="Departamento Regional" rules="required">
                                <v-select id="departamento-input" v-model="search.departamento"
                                    :options="departamentoSelect" label="descricao"
                                    placeholder="Selecione um departamento" :clearable="true" :disabled="loadingInputs">
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                </v-select>
                                <small v-if="errors[0]" class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Unidade de Atendimento -->
                    <b-col lg="3" md="6" sm="12">
                        <b-form-group label="Unidade de Atendimento*" label-for="unidade-input"
                            label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="Unidade de Atendimento" rules="required">
                                <div v-b-tooltip.hover.top="'Você precisa selecionar um departamento primeiro'"
                                    :disabled="Boolean(search.departamento)">
                                    <v-select id="unidade-input" v-model="search.unidade" :options="unidadeSelect"
                                        label="descricao" placeholder="Selecione uma unidade" :clearable="true"
                                        :disabled="!search.departamento">
                                        <span slot="no-options">Nenhuma opção selecionável.</span>
                                    </v-select>
                                </div>
                                <small v-if="errors[0]" class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Data de Início -->
                    <b-col lg="3" md="3" sm="3">
                        <b-form-group label="Data Início*" label-for="inicio-input" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="Data de Início" rules="required">
                                <b-input-group>
                                    <b-form-input class="form-control" id="inicio-input" v-model="input.inicio"
                                        v-mask="'##/##/####'" placeholder="00/00/0000" autocomplete="off"
                                        @input="setInicioInput" />
                                    <b-input-group-append>
                                        <b-form-datepicker class="form-control d-flex align-items-center" locale="pt-BR"
                                            v-model="search.dataInicio" button-only right :hide-header="true"
                                            label-help="Selecione a data de início" button-variant="custom-blue"
                                            clearable @input="setInicioPicker" />
                                    </b-input-group-append>
                                </b-input-group>
                                <small v-if="errors[0]" class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Data Final -->
                    <b-col lg="3" md="3" sm="3">
                        <b-form-group label="Data Final*" label-for="final-input" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="Data Final" rules="required">
                                <b-input-group>
                                    <b-form-input class="form-control" id="final-input" v-model="input.final"
                                        v-mask="'##/##/####'" placeholder="00/00/0000" autocomplete="off"
                                        @input="setFinalInput" />
                                    <b-input-group-append>
                                        <b-form-datepicker class="form-control d-flex align-items-center" locale="pt-BR"
                                            v-model="search.dataFinal" button-only right :hide-header="true"
                                            label-help="Selecione a data final" button-variant="custom-blue" clearable
                                            @input="setFinalPicker" />
                                    </b-input-group-append>
                                </b-input-group>
                                <small v-if="errors[0]" class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Usuário -->
                    <b-col lg="4" md="6" sm="12">
                        <b-form-group label="Usuário*" label-for="usuario-input" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="Usuário" rules="required">
                                <div v-b-tooltip.hover.top="'Você precisa selecionar uma unidade primeiro'"
                                    :disabled="Boolean(search.unidade)">
                                    <v-select id="usuario-input" v-model="search.usuario" :options="usuarioSelect"
                                        label="descricao" placeholder="Selecione um usuário" :clearable="true"
                                        :disabled="!search.unidade">
                                        <template #no-options>
                                            <div v-if="loadingInputs" class="d-flex align-items-center">
                                                <b-spinner small type="grow" class="mr-1" />
                                                <span>Carregando usuários...</span>
                                            </div>
                                            <div v-else>
                                                Nenhuma opção selecionável.
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                                <small v-if="errors[0]" class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Tela -->
                    <b-col lg="4" md="6" sm="12">
                        <b-form-group label="Tela*" label-for="tela-input" label-class="font_size_label">
                            <validation-provider #default="{ errors }" name="Tela" rules="required">
                                <v-select id="tela-input" v-model="search.tela" :options="telaSelect" label="descricao"
                                    placeholder="Selecione uma tela" :clearable="true">
                                    <span slot="no-options">Nenhuma opção selecionável.</span>
                                </v-select>
                                <small v-if="errors[0]" class="text-danger">
                                    {{ errors[0] }}
                                </small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>

                    <!-- Palavra -->
                    <b-col lg="4" md="6" sm="12">
                        <b-form-group label="Palavra" label-for="palavra-input" label-class="font_size_label">
                            <b-form-input v-model="search.palavra" id="palavra-input"
                                placeholder="Pesquise uma palavra" />
                        </b-form-group>
                    </b-col>

                </b-row>

            </validation-observer>

            <b-row class="justify-content-center">
                <b-button @click="() => {
                    validateAndFilter();
                }" variant="primary-button">
                    <feather-icon icon="SearchIcon" class="mr-50" />
                    <span class="align-middle">Pesquisar</span>
                </b-button>

                <b-button type="reset" class="ml-2 cor_botao" @click="cleanSearch" variant="outline-primary">
                    <feather-icon icon="XIcon" class="mr-50" />
                    <span class="align-middle">Limpar</span>
                </b-button>
            </b-row>
            <div v-if="loadingData" class="d-flex justify-content-center my-3">
                <output class="spinner-border text-custom-blue" v-if="loadingData">
                    <span class="sr-only">Loading...</span>
                </output>
            </div>
            <hr>
            <div>
                <section class="filters pb-1 px-2" v-if="!loadingData">
                    <b-row align-h="between">
                        <b-col lg="6" md="6" sm="6">
                            <div class="d-flex justify-center-center align-items-center">
                                <span class="mr-1">Mostrar</span>
                                <v-select id="tableSize" v-model="paginationData.defaultSize"
                                    @input="updateTableSize($event)" :options="table.optionsSize" :clearable="false"
                                    style="width: 87px;" />
                            </div>
                        </b-col>

                        <b-col lg="6" md="6" sm=6>
                            <div class="d-flex align-items-center justify-content-end">
                                <b-button variant="outline-primary" class="cor_botao" @click="downloadCSV"
                                    :disabled="table.items.length === 0"
                                    :parameters="lastUsedFilters || paramsAuditoria">
                                    <feather-icon icon="DownloadIcon" size="18" aria-hidden="true" />
                                </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </section>
                <section class="list-historico" v-if="!loadingData">
                    <b-table id="tableHistorico" responsive :stickyColumn="true" :busy.sync="filtering"
                        :fields="table.fields" :items="table.items" @sort-changed="ordenarColuna" no-local-sorting
                        :no-sort-reset="true">
                        <template #cell(departamento)="row">
                            <span class="font-weight-bold">
                                {{ row.item.departamento ? row.item.departamento : '-' }}
                            </span>
                        </template>
                        <template #cell(unidade)="row">
                            <span class="font-weight-bold">
                                {{ row.item.unidade ? row.item.unidade : '-' }}
                            </span>
                        </template>
                        <template #cell(tela)="row">
                            <span class="font-weight-bold">
                                {{ getTelaLabel(row.item.tela) }}
                            </span>
                        </template>
                        <template #cell(data)="row">
                            <span class="font-weight-bold">
                                {{ row.item.data }}
                            </span>
                        </template>
                        <template #cell(hora)="row">
                            <span class="font-weight-bold">
                                {{ row.item.hora }}
                            </span>
                        </template>
                        <template #cell(usuario)="row">
                            <span class="font-weight-bold">
                                {{ row.item.usuario }}
                            </span>
                        </template>
                        <template #cell(acao)="row">
                            <span class="font-weight-bold rounded-pill custom" :class="{
                                insercao: row.item.acao === 'Inserção',
                                alteracao: row.item.acao === 'Alteração',
                                exclusao: row.item.acao === 'Exclusão'
                            }">
                                {{ row.item.acao }}
                            </span>
                        </template>
                        <template #cell(observacao)="row">
                            <span class="font-weight-bold" style="white-space: pre-line;">
                                {{ row.item.observacao }}
                            </span>
                        </template>
                    </b-table>
                    <div class="pb-2 px-1">
                        <span v-if="without" class="ml-1">Nenhum registro encontrado</span>
                        <b-col sm="12" class="mt-2">
                            <CustomPagination :paginacao="paginationData" @page-cliked="updateCurrentPage" />
                        </b-col>
                    </div>
                </section>
            </div>
        </main>
    </div>
</template>

<script>
import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    VBTooltip,
    BSpinner,
    BCard,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend
} from 'bootstrap-vue';
import {
    triangleWarnMessage,
} from '@/libs/sweetalerts';
import vSelect from 'vue-select';
import moment from 'moment';
import CustomPagination from '@/views/components/custom/pagination/CustomPagination.vue';
import InfograficoEstoqueCard from '@/views/components/custom/cards/InfograficoEstoqueCard.vue';
import InfoCard from '@/views/components/custom/cards/InfoCard.vue';
import PageHeader from '@/views/components/custom/page-header/PageHeader.vue';
import TableSwitch from '@/views/components/custom/table-switch/TableSwitch.vue';
import TimedAlert from '@/views/components/custom/timed-alert/TimedAlert.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CustomAlert from "@/views/components/custom/timed-alert/CustomAlert.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from '@validations'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {actions, subjects} from "@/libs/acl/rules";

export default {
    title: 'Histórico de alterações',

    components: {
        BForm,
        BCol,
        BRow,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        TableSwitch,
        BCard,
        vSelect,
        CustomPagination,
        PageHeader,
        TimedAlert,
        VuePerfectScrollbar,
        BSpinner,
        BFormDatepicker,
        BInputGroup,
        BInputGroupAppend,
        InfograficoEstoqueCard,
        InfoCard,
        CustomAlert,
        ValidationProvider,
        ValidationObserver,
    },

    directives: {
        'b-tooltip': VBTooltip
    },

    watch: {
        'search.departamento': {
            handler(novoDepartamento) {
                if (!novoDepartamento) {
                    this.unidadeSelect = [];
                    this.search.unidade = '';
                    return;
                }

                const id = novoDepartamento.id_departamento ?? null;
                this.loadUnidadesPorDepartamento(id);
            },
            immediate: false
        },
        'search.unidade': {
            handler(novaUnidade) {
                if (!novaUnidade) {
                    this.usuarioSelect = [];
                    this.search.usuario = '';
                    return;
                }

                const id = novaUnidade.id ?? null;
                this.loadUsuariosPorUnidade(id);
            },
            immediate: false
        }
    },

    data() {
        return {
            linkItems: [
                {
                    name: 'Auditoria',
                    active: true
                }
            ],
            filtering: false,
            loadingData: false,
            loadingInputs: false,
            telaSelect: [],
            usuarioSelect: [],
            departamentoSelect: [],
            unidadeSelect: [],
            table: {
                fields: [
                    { key: "departamento", label: "DEPARTAMENTO", sortable: true, class: 'mw-50' },
                    { key: "unidade", label: "UNIDADE", sortable: true, class: 'mw-50' },
                    { key: "tela", label: "TELA", sortable: true, class: 'mw-50' },
                    { key: "data", label: "DATA", sortable: true, class: 'mw-50' },
                    { key: "hora", label: "HORA", sortable: true, class: 'mw-50' },
                    { key: "usuario", label: "USUÁRIO", sortable: true, class: 'mw-50' },
                    { key: "acao", label: "AÇÃO", sortable: true, class: 'mw-50' },
                    { key: "observacao", label: "OBSERVAÇÃO", sortable: false, class: 'mw-150' },
                ],
                items: [],
                optionsSize: [10, 20, 50, 100],
                columnOrder: 'data',
                order: 'desc'
            },
            paginationData: {
                currentPage: 1,
                totalLines: 0,
                fromLine: 0,
                toLine: 0,
                defaultSize: 10,
            },
            search: {
                departamento: null,
                unidade: null,
                dataInicio: '',
                dataFinal: '',
                usuario: '',
                tela: null,
                palavra: '',
            },
            input: {
                inicio: null,
                final: null,
            },
            size: 0,
            without: false,
            required,
            isMasterOrDN: this.$can(actions.VISUALIZAR, subjects.AUDITORIA_DN),
            lastUsedFilters: null,
            todosItem: { id: null, descricao: 'Todos' },
            todasItem: { id: null, descricao: 'Todas' },
            dnAccessItem: {
                id_departamento: 1,
                descricao: 'Departamento Nacional',
            }
        }
    },
    mounted() {
        this.loadDepartamentos();
        this.loadSelectTelas();
        this.setDefaultDates();
    },

    methods: {
        setDefaultDates() {
          this.search.dataInicio = moment().subtract(30, 'days').format('YYYY-MM-DD');
          this.search.dataFinal = moment().format('YYYY-MM-DD');
          this.setFinalPicker(moment().format('YYYY-MM-DD'));
          this.setInicioPicker(moment().subtract(30, 'days').format('YYYY-MM-DD'));
        },
        async loadDepartamentos() {
            this.loadingInputs = true;

            const departamentoParameters = {
                ativo: true,
                todos: this.isMasterOrDN,
            };

            try {
                const departamentosResponse = await this.$http.get(this.$api.departamento(), {
                    params: departamentoParameters,
                });

                const data = departamentosResponse.data;
                this.departamentoSelect = [this.todosItem];
                if(this.isMasterOrDN) {
                    this.departamentoSelect.push(this.dnAccessItem);
                }

                this.search.departamento = this.todosItem;

                if (data.length > 0) {
                    this.departamentoSelect.push(...data);
                }
            } catch (err) {
                console.error('Erro ao carregar departamentos:', err);
            } finally {
                this.loadingInputs = false;
            }
        },

        async loadSelectTelas() {
            try {
                const telasResponse = await this.$http.get(this.$api.telas());
                const data = telasResponse.data;
                this.telaSelect = [this.todasItem];
                this.search.tela = this.todasItem;
                if (data.length > 0) {
                    this.telaSelect.push(...data);
                }
            } catch (err) {
                console.error('Erro ao carregar departamentos:', err);
            }
        },

        async loadUnidadesPorDepartamento(idDepartamento) {
            try {
                const params = {
                    ativo: 'all',
                    todos: this.isMasterOrDN
                };

                if (idDepartamento !== null) {
                    params.id_departamento = idDepartamento;
                }

                const { data } = await this.$http.get(this.$api.unidade(), { params });

                this.unidadeSelect = [this.todasItem];
                this.search.unidade = {...this.todasItem};

                if (data.length > 0) {
                    this.unidadeSelect.push(...data.map(u => ({ id: u.id_unidade, descricao: u.descricao_unidade })));
                }

            } catch (err) {
                console.error('Erro ao carregar unidades por departamento:', err);
            }
        },

        async loadUsuariosPorUnidade(idUnidade) {
            this.loadingInputs = true;

            try {
                const params = {
                    id_departamento: this.search?.departamento?.id_departamento ?? null,
                    id_unidade: idUnidade
                };

                const { data } = await this.$http.get(this.$api.usuariosAuditoria(), { params });

                let usuarios = this.filtrarUsuariosPorUnidade(data, idUnidade);

                this.usuarioSelect = [this.todosItem];
                this.search.usuario = this.todosItem;

                if (usuarios.length > 0) {
                    this.usuarioSelect.push(...usuarios.map(u => ({
                        id: u.id_usuario,
                        descricao: u.pessoa_fisica?.nome
                    })));
                }
            } catch (err) {
                console.error('Erro ao carregar usuários por unidade:', err);
            } finally {
                this.loadingInputs = false;
            }
        },

        filtrarUsuariosPorUnidade(usuarios, idUnidade) {
            if (idUnidade === null) return usuarios;

            return usuarios.filter(usuario => {
                const isUsuarioSesi = Array.isArray(usuario.unidade) &&
                    usuario.unidade.some(u => u.id_unidade === idUnidade);

                const isUsuarioEmpresa = usuario.usuario_empresa?.empresa?.empresa_endereco?.some(end =>
                    end.id_unidade === idUnidade
                );

                return isUsuarioSesi || isUsuarioEmpresa;
            });
        },

        loadData() {
            const params = this.paramsAuditoria;

            this.filtering = true;

            this.$http
                .get(this.$api.logsAuditoria(), { params })
                .then((response) => {
                    this.table.items = response.data.data;
                    this.without = response.data.length === 0;
                    this.size = response.total;
                    this.loadingData = false;
                    this.filtering = false;
                    this.startPagination(response.data.meta);
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        startPagination(data) {
            this.paginationData.currentPage = data.current_page;
            this.paginationData.totalLines = data.total;
            this.paginationData.fromLine = data.from;
            this.paginationData.toLine = data.to;
        },

        cleanSearch() {
            this.search.departamento = [{...this.todosItem}]
            this.search.unidade = [{...this.todasItem}]
            this.search.usuario = [{...this.todosItem}]
            this.search.tela = [{...this.todasItem}]
            this.search.palavra = ''
            this.setDefaultDates();
            this.$refs.itemRules.reset();
        },

        async downloadCSV() {
            const params = this.lastUsedFilters || this.paramsAuditoria;

            try {
                const res = await this.$http.get(this.$api.csvAuditoria(), { params });
                const conteudo = res.data;
                this.$helpers.downloadArchiveCsv(conteudo, 'historico_acoes');
            } catch (err) {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: err.response.data.error,
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            }
        },

        ordenarColuna(sort) {
            this.table.columnOrder = sort.sortBy;
            this.table.order = sort.sortDesc ? 'desc' : 'asc';

            this.filtering = true;

            this.loadData();
        },

        updateCurrentPage(page) {
            this.paginationData.currentPage = page;
            this.filtering = true;
            this.loadData();
        },

        updateTableSize(event) {
            if (!event) {
                this.paginationData.defaultSize = 10;
            }
            this.filtering = true;

            this.paginationData.currentPage = 1;
            this.loadData();
        },

        async validateAndFilter() {
            const isValid = await this.$refs.itemRules.validate();

            if (!isValid) {
                return;
            }

            this.filterData();
        },

        filterData() {
            const dataInicio = moment(this.search.inicio, 'YYYY-MM-DD', true);
            const dataFim = moment(this.search.final, 'YYYY-MM-DD', true);

            if (dataInicio.isValid() && dataFim.isValid()) {
                const diffDays = dataFim.diff(dataInicio, 'days');

                if (diffDays < 0) {
                    triangleWarnMessage('A data final não pode ser anterior à data inicial.');
                    return;
                }

                if (diffDays > 30) {
                    triangleWarnMessage('O intervalo entre as datas não pode ser superior a 30 dias.');
                    return;
                }
            }

            this.filtering = true;
            this.lastUsedFilters = { ...this.paramsAuditoria };
            this.loadData();
        },

        getTelaLabel(value) {
            const map = {
                registro_vacinados: 'Registro de Vacinados - Cadastrar/Editar',
                adesao: 'Adesão - Aderir Campanha',
                estoque: 'Estoque - Lote',
                usuario: 'Usuário - Gerenciar Usuários'
            };

            return map[value] || value || '—';
        },

        setInicioInput(value) {
            this.input.dataInicio = value;
            this.search.inicio = value ? moment(this.input.inicio, 'DD/MM/YYYY').format('YYYY-MM-DD') : value;
        },

      setInicioPicker(value) {
        this.search.inicio = value;
        this.input.inicio = value ? moment(this.search.inicio).format('DD/MM/YYYY') : value;
      },

      setFinalInput(value) {
        this.input.final = value;
        this.search.final = value ? moment(this.input.final, 'DD/MM/YYYY').format('YYYY-MM-DD') : value;
      },

      setFinalPicker(value) {
        this.search.final = value;
        this.input.final = value ? moment(this.search.final).format('DD/MM/YYYY') : value;
      },
    },

    computed: {
        paramsAuditoria() {
            return {
                id_departamento: this.search?.departamento?.id_departamento ?? null,
                id_unidade: this.search.unidade?.id ?? null,
                data_inicial: this.search.dataInicio,
                data_final: this.search.dataFinal,
                id_usuario: this.search.usuario?.id ?? null,
                id_tela_sistema: this.search?.tela?.id_tela_sistema,
                palavra: this.search.palavra,
                tamanho: this.paginationData.defaultSize,
                pagina: this.paginationData.currentPage,
                colunaOrdenar: this.table.columnOrder,
                ordem: this.table.order
            };
        },
    },

}

</script>

<style>
.custom {
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 5px;
    font-weight: 400;
}

.insercao {
    background-color: #e3f6f4;
    color: #21a696;
}

.alteracao {
    background-color: #e5eef7;
    color: #4c75b7;
}

.exclusao {
    background-color: #fceaea;
    color: #e76179;
}

.cor_botao {
    color: #2772C0 !important;
    border: 1px solid #2772C0 !important;
}

.cor_botao[disabled] {
    background-color: #F0F0F0 !important;
    border: 1px solid #6E6B7B !important;
    color: #AEAEAE !important;
    cursor: not-allowed !important;
    box-shadow: none !important;
    opacity: 1 !important;
}

.cor_botao[disabled] svg {
    stroke: #999 !important;
}

.hidden_overflow_tabela {
    overflow: visible !important;
}
</style>
